import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function BackToFleetButton() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBack = () => {
    navigate('/', { state: { scrollToFleet: true } });
  };

  return (
    <button
      onClick={handleBack}
      className="inline-flex items-center gap-2 px-5 py-2.5 bg-white text-navy-800 font-semibold text-sm rounded-full border border-sand-200 hover:bg-coral-500 hover:text-white hover:border-coral-500 transition-all duration-200 cursor-pointer whitespace-nowrap"
    >
      <i className="ri-arrow-left-line text-base"></i>
      <span>{t('common.backToFleet')}</span>
    </button>
  );
}